var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google-TV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chairside-Education-overview,-Remove-video-from-My-list-button-focused",
    transform: "translate(-302.000000, -608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1-Copy-15"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(328.000000, 634.000000) rotate(-315.000000) translate(-328.000000, -634.000000) translate(310.000000, 616.000000)",
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,-2.57175828e-15 C19.5522847,-2.53794059e-15 20,0.44771525 20,1 L20,16 L35,16 C35.5522847,16 36,16.4477153 36,17 L36,19 C36,19.5522847 35.5522847,20 35,20 L19.999,20 L20,35 C20,35.5522847 19.5522847,36 19,36 L17,36 C16.4477153,36 16,35.5522847 16,35 L15.999,20 L1,20 C0.44771525,20 -3.4850783e-15,19.5522847 -3.55271368e-15,19 L-3.55271368e-15,17 C-3.62034905e-15,16.4477153 0.44771525,16 1,16 L16,16 L16,1 C16,0.44771525 16.4477153,-2.97297001e-15 17,-2.93915232e-15 L19,-2.57175828e-15 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.81497a19.svg";
export { ForwardRef as ReactComponent };